import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router'

import { OverlayService } from '../services/overlay.service'
import { IndustryService } from '../services/industry.service'
import { UserService } from '../services/user.service'
import { ReviewService } from '../services/review.service'

import { NoSanitizePipe } from "../services/pipes/no-sanitize.pipe";

import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { EmployersPageComponent } from '../pages/employers.component';

import * as moment from 'moment';
import { getOrCreateContainerRef } from '@angular/core/src/render3/di';
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'app-course-provider',
    templateUrl: './course-provider.component.html',
    animations: [fadeInUp]
})
export class CourseProviderPageComponent implements OnInit, OnDestroy {
    currentUser: any
    industrySlug: any
    industries: any
    industry: any
    industryId: any
    careerSlug: any
    career: any
    courseSlug: any
    course: any
    providerSlug: any
    provider: any
    reviews: any
    reviewsCopy: any
    currentUserReview: any
    reviewsFor: any = { course: undefined, provider: undefined }

    // Template variables
    openedComment: any = null
    selectUserType: any = 'All'
    isFav: Boolean = undefined
    isFavProcessing: Boolean = true
    showFavMsgTimeout: any
    showFavMsg: Boolean = false
    showLeaveReview: Boolean = false
    otherUserTypeMessage: String
    alreadyReviewedWarning: Boolean = false
    alreadyReviewedWarningTimeout: any
    studentRating: any = 'N/A'
    employerRating: any = 'N/A'
    overallRating: any = 'N/A'
    overallProviderRating: any = 'N/A'
    filterOptions: Array<any> = ['Most Recent', 'Most Liked', 'Top Rated']
    reviewsLoader: Boolean = true
    eventsSubscription: any
    isIndustryUrl: Boolean = false
    paramsChangeSubsciption: any
    currentCourse: string
    currentProvider: string
    showFilters: Boolean = false
    descriptionExpanded: Boolean = false

    constructor(
        private route: ActivatedRoute,
        private overlayService: OverlayService,
        private userService: UserService,
        private industryService: IndustryService,
        private reviewService: ReviewService,
        private router: Router,
        private title: Title
    ) {
        this.eventsSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (event.url.startsWith('/course')) {
                    this.isIndustryUrl = false
                } else if (event.url.startsWith('/industry')) {
                    this.isIndustryUrl = true
                }
            }
        })

        this.paramsChangeSubsciption = this.route.params.subscribe(params => {
            const provider = params.provider
            const course = params.course

            let providerTitle = this.industryService.getTitleString(provider)
            let courseTitle = this.industryService.getTitleString(course)

            const title = providerTitle + ' | ' + courseTitle
            this.title.setTitle(title)

            if (this.currentCourse !== params.course && this.currentProvider !== params.provider) {
                this.fetchDetails()
            }
        })
    }

    ngOnDestroy() {
        if (this.eventsSubscription) {
            this.eventsSubscription.unsubscribe()
        }
        if (this.paramsChangeSubsciption) {
            this.paramsChangeSubsciption.unsubscribe()
        }
    }

    ngOnInit() {
        this.fetchDetails()
    }

    fetchDetails() {
        if (this.isIndustryUrl) {
            this.industrySlug = this.route.snapshot.params['industry']
            this.careerSlug = this.route.snapshot.params['career']
        }
        this.courseSlug = this.route.snapshot.params['course']
        this.providerSlug = this.route.snapshot.params['provider']

        this.getCurrentUser()

        if (this.isIndustryUrl) {
            this.industryService.getIndustries()
            this.industryService.Industries.subscribe(industries => {
                if (industries && industries.length > 0) {
                    this.industries = industries
                    this.industry = this.industries.filter(elm => elm.slug === this.industrySlug)[0]
					this.industryId = this.industry._id
                }
            })

            this.industryService.getCareerBySlug(this.careerSlug).subscribe(career => {
                this.career = career.json()
            }, err => {
                console.log(err);
            })
        }

        this.industryService.getCourseBySlug(this.courseSlug).subscribe(course => {
            this.course = course.json()
            // Get the industry id of the first course
            if (!this.isIndustryUrl) {
                this.getIndustryId(this.course.careers[0])
            }
            this.currentCourse = this.course.slug
            this.reviewsFor.course = this.course._id
            this.getReviews()
            this.checkIfFav()
            this.checkIfReviewed()
        }, err => {
            console.log(err);
        })

        this.industryService.getProviderBySlug(this.providerSlug).subscribe(provider => {
            this.provider = provider.json()
            this.currentProvider = this.provider.slug
            this.reviewsFor.provider = this.provider._id
            this.getReviews()
            this.checkIfFav()
            this.checkIfReviewed()
            this.getOverallProviderRating()
            setTimeout(() => {
                this.checkDescSize()
            }, 1000);
        }, err => {
            console.log(err);
        })
    }

    getIndustryId(career) {
        if (career) {
            const careerId = career._id
            this.industryService.getIndustryIdForCourse(careerId).subscribe(res => {
                const result = res.json()
                this.industryId = result.industry
            }, err => {
                console.log(err)
            })
        }
    }

    getOverallProviderRating() {
        this.industryService.getOverallProviderRating(this.provider._id).subscribe(rating => {
            rating = rating.json()
            if (rating && rating.totalScore) {
                this.overallProviderRating = rating.totalScore / rating.count
                if ((Math.floor(this.overallProviderRating) - this.overallProviderRating) !== 0) {
                    this.overallProviderRating = this.overallProviderRating.toFixed(1)
                }
            }
        }, err => {
            console.log(err);
        })
    }

    getCurrentUser() {
        this.userService.getCurrentUser()
        this.userService.currentUser.subscribe((currentUser) => {
            this.currentUser = currentUser
            this.checkIfFav()
            this.checkIfReviewed()
        })
    }

    getReviews() {
        if (this.reviewsFor && this.reviewsFor.course && this.reviewsFor.provider) {
            this.reviewService.getReviewsFor(this.reviewsFor).subscribe(reviews => {
                this.reviews = reviews.json()
				this.reviewsLoader = false
                if (this.reviews && this.reviews.length > 0) {
                    this.provider.reviewCount = this.reviews.length
                    this.reviewsCopy = JSON.parse(JSON.stringify(reviews))
                    this.currentUserReview = this.reviews.filter(obj => {
                        return obj.user._id === this.currentUser._id
                    })
                    this.mapQuestions()
                    this.calcRatings()
                    this.filterItems()
                }
            })
        }
    }

    getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.provider.distance = this.calcDistance(position.coords.latitude, position.coords.longitude, this.provider.location.Latitude, this.provider.location.Longitude)
            });
        }
    }

    calcDistance(lat1, lon1, lat2, lon2) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            let radlat1 = Math.PI * lat1 / 180;
            let radlat2 = Math.PI * lat2 / 180;
            let theta = lon1 - lon2;
            let radtheta = Math.PI * theta / 180;
            let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344
            return dist.toFixed(0);
        }
    }

    checkIfFav() {
        if (this.currentUser && this.course && this.provider) {
            this.isFav = false
            if (this.currentUser.favourites && this.currentUser.favourites.length > 0) {
                for (let i = 0; i < this.currentUser.favourites.length; i++) {
                    const element = this.currentUser.favourites[i];
                    if (element.course === this.course._id && element.provider === this.provider._id) {
                        this.isFav = true
                    }
                }
            }
            this.isFavProcessing = false
        }
    }

    checkIfReviewed() {
        if (this.currentUser && (this.currentUser.userType === 'Student' || this.currentUser.userType === 'Employer') && this.course && this.provider && !this.showLeaveReview) {
            const data = {
                userId: this.currentUser._id,
                courseId: this.course._id,
                providerId: this.provider._id
            }
            this.reviewService.checkIfUserReviewed(data).subscribe(res => {
                const result = res.json()
                if (!result) {
                    this.showLeaveReview = true
                } else {
                    this.showLeaveReview = false
                }
            })
        }
        if (this.currentUser && this.currentUser.userType !== 'Student' && this.currentUser.userType !== 'Employer') {
            if (this.currentUser.userType === 'Other') {
                this.otherUserTypeMessage = `* As an ${this.currentUser.userType} user, you do not have the ability to leave a review.`
            } else {
                this.otherUserTypeMessage = `* As a ${this.currentUser.userType} user, you do not have the ability to leave a review.`
            }
        } else {
            this.otherUserTypeMessage = null
        }
    }

    mapQuestions() {
        this.reviews = this.reviews.map(elm => {
            let newElm = elm
            newElm.previewQs = []
            newElm.hiddenQs = []
            let qs = elm.review.questions
            if (qs.completedCourse === 'No' || qs.completedCourse === 'My employee(s) did not complete the course') {
                newElm.previewQs.push({
                    label: (elm.review.userType === 'Employer' ? 'Did your employee(s) complete this course before you employed them?' : 'Did you complete this course?'),
                    answer: qs.completedCourse
                })
            } else {
                if (elm.review.userType === 'Student') {
                    if (qs.howWasCourseDelivered) newElm.previewQs.push({ label: 'How was this course delivered?', answer: qs.howWasCourseDelivered })
                    if (qs.involveAnyPracticalWorkExperience) newElm.previewQs.push({ label: 'Did this course involve any practical work experience?', answer: qs.involveAnyPracticalWorkExperience })
                    if (qs.assessmentsBasedOnRealisticActivities) newElm.previewQs.push({ label: 'Course assessments were based on realistic work activities', answer: qs.assessmentsBasedOnRealisticActivities })
                    if (qs.trainersWereKnowledgeable) newElm.previewQs.push({ label: 'The trainer(s) understood the course content and was knowledgeable about the industry this course related to', answer: qs.trainersWereKnowledgeable })

                    if (qs.easeOfAdministrationProcedures) newElm.hiddenQs.push({ label: 'Overall, how easy or difficult did you find the administration procedures of your training provider', answer: qs.easeOfAdministrationProcedures })
                    if (qs.whoArrangedWork) newElm.hiddenQs.push({ label: 'Who arranged the work experience?', answer: qs.whoArrangedWork })
                    if (qs.workExperienceWasBeneficial) newElm.hiddenQs.push({ label: 'The work experience I completed was beneficial to building my skills and knowledge in the industry this course was related to.', answer: qs.workExperienceWasBeneficial })
                    if (qs.trainersWereResponsive) newElm.hiddenQs.push({ label: 'The trainers were responsive and provided support and assistance when I needed it during this course. ', answer: qs.trainersWereResponsive })
                    if (qs.describesYourSituation) newElm.hiddenQs.push({ label: 'Which of the following statements best describes your work situation: ', answer: qs.describesYourSituation })
                    if (qs.howLikelyYouRecommend) newElm.hiddenQs.push({ label: 'Based on your experience of completing this course, how likely or unlikely are you to recommend your training provider to others? ', answer: qs.howLikelyYouRecommend })

                } else {
                    if (qs.trainingProviderDiscussedRequirements) newElm.previewQs.push({ label: 'Did the training provider discuss your requirements and expectations prior to delivering the course?', answer: qs.trainingProviderDiscussedRequirements })
                    if (qs.trainersWereKnowledgeable) newElm.previewQs.push({ label: 'The trainer(s) demonstrated a sound understanding of our industry and business needs.', answer: qs.trainersWereKnowledgeable })
                    if (qs.trainingImprovedEmployeeKnowledge) newElm.previewQs.push({ label: 'The training improved the employee’s knowledge and skills in areas relevant to the job role.', answer: qs.trainingImprovedEmployeeKnowledge })
                    if (qs.howLikelyYouUseThisTrainingProvider) newElm.previewQs.push({ label: 'How likely or unlikely are you to use this training provider to source skilled potential employees?', answer: qs.howLikelyYouUseThisTrainingProvider })

                    if (qs.workExperienceWasBeneficial) newElm.hiddenQs.push({ label: 'Work-based training in this course was particularly valuable to build their skills and knowledge for the role you hired them for.', answer: qs.workExperienceWasBeneficial })
                    if (qs.courseWasBeneficialToJobRole) newElm.hiddenQs.push({ label: 'Completing this course was beneficial to employee(s) job role: ', answer: qs.courseWasBeneficialToJobRole })
                    if (qs.trainingMetBusinessNeeds) newElm.hiddenQs.push({ label: 'The discussions I had with the training provider ensured the training delivered met my business needs. ', answer: qs.trainingMetBusinessNeeds })
                    if (qs.metYourExpectations) newElm.hiddenQs.push({ label: 'The skills and knowledge demonstrated by the employee met your expectations: ', answer: qs.metYourExpectations })
                }
            }
            return newElm
        })
    }

    calcRatings() {
        let student = this.reviews.filter(elm => elm.review.userType === 'Student').map(elm => elm.review.score)
        if (student && student.length > 0) {
            this.studentRating = student.reduce((sum, elm) => sum + elm) / student.length
            if ((Math.floor(this.studentRating) - this.studentRating) !== 0) {
                this.studentRating = this.studentRating.toFixed(1)
            }
        }

        let employer = this.reviews.filter(elm => elm.review.userType === 'Employer').map(elm => elm.review.score)
        if (employer && employer.length > 0) {
            this.employerRating = employer.reduce((sum, elm) => sum + elm) / employer.length
            if ((Math.floor(this.employerRating) - this.employerRating) !== 0) {
                this.employerRating = this.employerRating.toFixed(1)
            }
        }

        this.overallRating = this.reviews.map(elm => elm.review.score).reduce((sum, elm) => sum + elm) / this.reviews.length
        if ((Math.floor(this.overallRating) - this.overallRating) !== 0) {
            this.overallRating = this.overallRating.toFixed(1)
        }
    }

    formatDate(val) {
        return 'posted ' + moment(val).format('DD.MM.YY')
    }

    addToFavourite() {
        const body = {
            action: 'add',
            userId: this.currentUser._id,
            courseId: this.course._id,
            providerId: this.provider._id
        }
        if (this.isFav) {
            body.action = 'remove'
        }
        this.isFavProcessing = true
        this.userService.addOrRemoveFavourite(body).then(result => {
            this.getCurrentUser()
            this.showFavMsg = true
            clearTimeout(this.showFavMsgTimeout)
            this.showFavMsgTimeout = setTimeout(() => {
                this.showFavMsg = false
            }, 3000)
        }).catch(error => {
            console.log(error);
        })
    }

    filterSelect(item, select) {
        if (item === 'user') {
            this.selectUserType = select.target.value
        } else if (item === 'filter') {
            this.filterItems(select.target.value)
        }
    }

    filterItems(val = 'Most Recent') {
        this.reviews.sort((a, b) => {
            let returnVal = 0
            if (val === 'Most Recent') {
                if (moment(a.review.createdAt).valueOf() < moment(b.review.createdAt).valueOf()) returnVal = 1;
                if (moment(a.review.createdAt).valueOf() > moment(b.review.createdAt).valueOf()) returnVal = -1;
            } else if (val === 'Top Rated') {
                if (a.review.score < b.review.score) returnVal = 1;
                if (a.review.score > b.review.score) returnVal = -1;
            } else if (val === 'Most Liked') {
                if (a.review.likes.length < b.review.likes.length) returnVal = 1;
                if (a.review.likes.length > b.review.likes.length) returnVal = -1;
            }
            return returnVal;
        })
    }

    likeDislikeReview(action, review) {
        let newaction = action
        if (action === 'like' && review.review.likes.includes(this.currentUser._id)) {
            newaction = 'removelike'
        }
        if (action === 'dislike' && review.review.dislikes.includes(this.currentUser._id)) {
            newaction = 'removedislike'
        }
        const body = {
            action: newaction,
            reviewId: review.review._id,
            userId: this.currentUser._id
        }
        this.reviewService.likeOrDislikeReview(body).then(result => {
            this.getReviews()
        }).catch(error => {
            let err = error.json()
        })
    }

    openShareCourseOverlay() {
        document.getElementsByTagName('html')[0].classList.add('scroll-lock')
        setTimeout(function () {
            document.getElementById('sharereview-overlay').classList.add('is-block')
        }, 10)
        setTimeout(function () {
            document.getElementById('sharereview-overlay').classList.add('is-visible')
        }, 20)
    }

    closeShareCourseOverlay() {
        document.getElementsByTagName('html')[0].classList.remove('scroll-lock')
        document.getElementById('sharereview-overlay').classList.remove('is-visible')
        setTimeout(function () {
            document.getElementById('sharereview-overlay').classList.remove('is-block')
        }, 500)
    }

    openReviewOverlay() {
        if (!this.showLeaveReview) {
            this.alreadyReviewedWarning = true
            clearTimeout(this.alreadyReviewedWarningTimeout)
            this.alreadyReviewedWarningTimeout = setTimeout(() => {
                this.alreadyReviewedWarning = false
            }, 10000);
        } else {
            document.getElementById('Main').classList.add('is-hidden')
            this.overlayService.overlayData.next({
                component: 'LeaveReviewComponent',
                inputs: {
                    content: {
                        currentUser: this.currentUser,
                        provider: this.provider,
                        course: this.course,
						industry: this.industryId
                    }
                }
            })
        }
    }

    displayScoreStars(value) {
        let starsSvgs = ''
        let toAdd = (5 - value)
        for (let i = 0; i < Math.floor(value); i++) {
            starsSvgs += '<svg class="c-svgicon c-svgicon--star-full" viewBox="0 0 28 27"><use xlink:href="assets/img/inline.svg#star-full"></use></svg>'
        }
        if (value - Math.floor(value) >= .5) {
            starsSvgs += '<svg class="c-svgicon c-svgicon--star-half" viewBox="0 0 28 27"><use xlink:href="assets/img/inline.svg#star-half"></use></svg>'
            toAdd = (5 - value) - .5
        }
        for (let i = 0; i < toAdd; i++) {
            starsSvgs += '<svg class="c-svgicon c-svgicon--star-empty" viewBox="0 0 28 27" *ngIf="star === 0"><use xlink:href="assets/img/inline.svg#star-empty"></use></svg>'
        }
        return starsSvgs
    }

    openComment(target) {
        const elmsLink = document.getElementsByClassName('comment-link')
        const targetElmlink = document.getElementsByClassName('comment-link-' + target)
        const elms = document.getElementsByClassName('comment-content')
        const targetElm = document.getElementsByClassName('comment-content-' + target)
        for (var i = 0; i < elms.length; i++) {
            elmsLink[i].classList.remove('open')
            elms[i].classList.remove('open')
            elms[i]['style'].maxHeight = 0
        }
        if (target !== this.openedComment) {
            targetElmlink[0].classList.add('open')
            targetElm[0].classList.add('open')
            targetElm[0]['style'].maxHeight = targetElm[0]['scrollHeight'] + 'px'
            this.openedComment = target
        } else {
            this.openedComment = null
        }
    }

    checkDescSize() {
        const descElem = document.getElementsByClassName('c-courseprovider__desc')[0]
        const descMoreElem = document.getElementsByClassName('c-courseprovider__desc-more')[0]
        if (descElem && descElem['scrollHeight'] > 300) {
            descElem['style'].maxHeight = '180px'
            descMoreElem.classList.add('is-visible')
        }
    }
    openDescription() {
        const targetElem = document.getElementsByClassName('c-courseprovider__desc-more')[0]
        this.descriptionExpanded = !this.descriptionExpanded
        const descElem = document.getElementsByClassName('c-courseprovider__desc')
        if (this.descriptionExpanded) {
            descElem[0]['style'].maxHeight = descElem[0]['scrollHeight'] + 'px'
            targetElem.classList.add('is-open')
        } else {
            descElem[0]['style'].maxHeight = '180px'
            targetElem.classList.remove('is-open')
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/industries/course-provider.component.ts